import { Blockchain } from "@rarible/api-client"
import { mainnet } from "viem/chains"
import { toCurrencyId } from "../../../price/types"
import { FEE_CONFIG_URL } from "../constants"
import type { StaticEthereumBlockchainConfig } from "../types"

export const ethereumConfig: StaticEthereumBlockchainConfig = {
  name: "Ethereum",
  icon: "/images/blockchains/ethereum.svg",
  isEvm: true,
  testnet: false,
  isTestnet: false,
  feesVersion: "v3",
  unionApi: "https://api.rarible.org",
  basePath: "https://ethereum-api.rarible.org",
  chainId: mainnet.id,
  treasury: "0x64d34BcfC32Fb663172C47d6E4Fb1dBFaba6e7a2",
  blockchain: Blockchain.ETHEREUM,
  chainName: mainnet.name,
  exchange: {
    v2: "0x9757F2d2b135150BBeb65308D4a91804107cd8D6",
    wrapper: "0x9BDB46adb3972f9a5e2eadCcd009f0bf3e386845",
  },
  blockExplorers: [
    {
      url: "https://etherscan.io",
      icon: "/images/scanner.svg",
      adress: "https://etherscan.io/address/${adrress}",
    },
  ],
  rpcUrls: [],
  privateRpcNodeSlug: "ethereum-node",
  transferProxies: {
    nft: "0x4fee7b061c97c9c496b01dbce9cdb10c02f0a0be",
    erc721Lazy: "0xbb7829BFdD4b557EB944349b2E2c965446052497",
    erc20: "0xb8e4526e0da700e9ef1f879af713d691f81507d8",
  },
  feeConfigUrl: FEE_CONFIG_URL,
  primaryCurrency: {
    id: toCurrencyId("ETHEREUM:0x0000000000000000000000000000000000000000"),
    symbol: "ETH",
    name: "Ethereum",
    decimals: 18,
  },
  wrappedCurrency: {
    id: toCurrencyId("ETHEREUM:0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2"),
    symbol: "WETH",
    name: "Wrapped Ethereum",
    decimals: 18,
  },
  addFundsLink: "https://rarible.com/ethereum/swap",
  hasStabilityProtocol: true,
  viem: mainnet,
}

export const getEthereumConfig = (): StaticEthereumBlockchainConfig =>
  ethereumConfig
